export default function (files) {
  if (files.length) {
    this.uploadFile(files[0])
  }
}
